/* eslint-disable @nx/enforce-module-boundaries */
import { log } from '@intigral/utils';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import users from '../../actions/users';
import { screenDetailTypes } from '../../config/constants';
import h from '../../helpers/common';
import url from '../../helpers/url';
import user from '../../helpers/user';
import { initialState } from '../defaultState';
import { getProfileListFromCache, refreshProfileListQuery } from '../../utils/profileListQuery';
import { loadProfileDone, selectProfileDone } from './profileSlice';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ISubscriptionService } from '@intigral/domain/lib/application/services/SubscriptionService';
import { IUserRevisionService } from '@intigral/domain/lib/application/services/UserRevisionService';
import { isGuestUser } from '../../config/guestMode';

export const fetchUserRevision = createAsyncThunk('fetch/userRevision', async (params, ThunkAPI) => {
    const accountId = h.getAccountId();
    const bucketId = h.getBucketIdFromAccountId(accountId);
    const userRevisionSrvice = container.resolve<IUserRevisionService>(DI.SERVICES.IUserRevisionService);

    return await userRevisionSrvice
        .getUserRevision(bucketId)
        .then(async (results) => {
            try {
                const userRevision = results[accountId];
                if (userRevision) {
                    const { revision } = <any>ThunkAPI.getState();
                    const { profile } = <any>ThunkAPI.getState();
                    const { selectedProfile, profileList } = profile;
                    const cachedProfileList = profileList ?? getProfileListFromCache();
                    const profileArray = cachedProfileList?.profiles ?? [];
                    const deleted =
                        profileArray.length > 0 ? user.isSelectedProfileDeleted(selectedProfile, profileArray) : false;
                    const isInitialRevisionSync = revision.prev === 0;
                    const profileRevisionChanged = revision.prev !== 0 && revision.prev !== userRevision.prev;
                    const isGuest = isGuestUser(user.getUserInfo());

                    if (user.isForceLogoutAblied(userRevision.flRev)) {
                        users.callTrack('NA', 'Forcelogout from user revision');
                        users.logoutUser();
                    }
                    if (!isGuest && user.isUserSubscriptionRevChanges(userRevision.subRev)) {
                        const currentUser = user.getUserInfo();
                        const subscription = await container
                            .resolve<ISubscriptionService>(DI.SERVICES.ISubscriptionService)
                            .getSubscriptionStatus(
                                currentUser.apiKey,
                                currentUser.username,
                                currentUser.authToken,
                                currentUser.identityToken
                            );
                        user.updateUserSubscriptionsObject(subscription, false);
                    }
                    if (profileRevisionChanged || (deleted && !isInitialRevisionSync)) {
                        const profiles = await refreshProfileListQuery();
                        ThunkAPI.dispatch(setUserRevision(userRevision));
                        ThunkAPI.dispatch(loadProfileDone(profiles ?? []));
                        const { profile: updatedProfileState } = <any>ThunkAPI.getState();
                        const { selectedProfile: currentSelectedProfile, profileList: updatedProfileList } =
                            updatedProfileState;

                        if (currentSelectedProfile) {
                            ThunkAPI.dispatch(selectProfileDone(currentSelectedProfile));
                        }
                        const isDeleted = user.isSelectedProfileDeleted(
                            currentSelectedProfile,
                            updatedProfileList?.profiles ?? []
                        );
                        if (isDeleted && currentSelectedProfile !== null && currentSelectedProfile.profileGuid) {
                            if (
                                !url.isCurrentRoute('add-profile') &&
                                !url.isCurrentRoute('edit-profile') &&
                                !url.isCurrentRoute(url.getDetailsPage(screenDetailTypes.PROFILE_SETTINGS)) &&
                                !url.isCurrentRoute(url.getDetailsPage(screenDetailTypes.PROFILE_SELECT))
                            ) {
                                // ToDo
                            }
                            return false;
                        }
                        return true;
                    }

                    if (isInitialRevisionSync && cachedProfileList) {
                        ThunkAPI.dispatch(loadProfileDone(cachedProfileList));
                    }

                    ThunkAPI.dispatch(setUserRevision(userRevision));
                    return true;
                }
            } catch (error) {
                ThunkAPI.dispatch(revisionError(error));
                return false;
            }
        })
        .catch((error) => {
            ThunkAPI.dispatch(revisionError(error));
            return false;
        });
});

const userRevisionSlice = createSlice({
    name: 'UserRevision',
    initialState: initialState.revision,
    reducers: {
        setUserRevision: (state, action) => {
            state = { ...state, ...action.payload };
            return state;
        },
        clearSearchResult: () => {
            return initialState.revision;
        },
        revisionError: (state, action) => {
            return state;
        },
    },
});

export const { setUserRevision, clearSearchResult, revisionError } = userRevisionSlice.actions;

export default userRevisionSlice.reducer;
